import React, { useState } from 'react';
import { Header } from './components/Header';
import { MainContent } from './components/MainContent';
import { Sidebar } from './components/Sidebar';
import { Footer } from './components/Footer';
import { ThemeProvider, useTheme, eraInfo } from './contexts/ThemeContext';
import { ThemeSwitcher } from './components/ThemeSwitcher';
import { EraVisualEffects } from './components/EraVisualEffects';
import { CommunityResourceWall } from './components/CommunityResourceWall';
import { ZineWorkshopPage } from './components/ZineWorkshopPage';
import './styles/era-styles.css';
function MagazineContent() {
  const {
    currentEra
  } = useTheme();
  const [currentView, setCurrentView] = useState<'magazine' | 'resources' | 'workshop'>('magazine');
  return <div className={`min-h-screen ${eraInfo[currentEra].className}`} data-id="element-0">
      <EraVisualEffects data-id="element-1" />
      {currentView === 'magazine' && <div className="magazine-container min-h-screen" data-id="element-2">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
            <Header data-id="element-4" />
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-8" data-id="element-5">
              <MainContent data-id="element-6" />
              <Sidebar data-id="element-7" />
            </div>
            <div className="mt-8 flex justify-center gap-4 flex-wrap" data-id="element-8">
              <button onClick={() => setCurrentView('resources')} className={`px-4 py-2 font-bold text-sm uppercase ${currentEra === '60s' ? 'bg-black text-white' : currentEra === '70s' ? 'bg-amber-800 text-white rounded-full' : currentEra === '80s' ? 'bg-cyan-400 text-black' : currentEra === '90s' ? 'bg-pink-500 text-black' : 'bg-blue-600 text-white rounded'}`} data-id="element-9">
                View Community Resource Wall
              </button>
              <button onClick={() => setCurrentView('workshop')} className={`px-4 py-2 font-bold text-sm uppercase ${currentEra === '60s' ? 'bg-black text-white' : currentEra === '70s' ? 'bg-amber-800 text-white rounded-full' : currentEra === '80s' ? 'bg-yellow-400 text-black' : currentEra === '90s' ? 'bg-cyan-400 text-black' : 'bg-orange-500 text-white rounded'}`} data-id="element-10">
                Zine Workshop Details
              </button>
            </div>
            <Footer data-id="element-11" />
          </div>
        </div>}
      {currentView === 'resources' && <div className="magazine-container min-h-screen" data-id="element-12">
          <CommunityResourceWall data-id="element-13" />
          <div className="fixed bottom-4 left-4 z-50" data-id="element-14">
            <button onClick={() => setCurrentView('magazine')} className={`px-4 py-2 font-bold text-sm uppercase ${currentEra === '60s' ? 'bg-black text-white' : currentEra === '70s' ? 'bg-amber-800 text-white rounded-full' : currentEra === '80s' ? 'bg-cyan-400 text-black' : currentEra === '90s' ? 'bg-pink-500 text-black' : 'bg-blue-600 text-white rounded'}`} data-id="element-15">
              Back to Magazine
            </button>
          </div>
        </div>}
      {currentView === 'workshop' && <div className="magazine-container min-h-screen" data-id="element-16">
          <ZineWorkshopPage data-id="element-17" />
          <div className="fixed bottom-4 left-4 z-50" data-id="element-18">
            <button onClick={() => setCurrentView('magazine')} className={`px-4 py-2 font-bold text-sm uppercase ${currentEra === '60s' ? 'bg-black text-white' : currentEra === '70s' ? 'bg-amber-800 text-white rounded-full' : currentEra === '80s' ? 'bg-cyan-400 text-black' : currentEra === '90s' ? 'bg-pink-500 text-black' : 'bg-blue-600 text-white rounded'}`} data-id="element-19">
              Back to Magazine
            </button>
          </div>
        </div>}
      <ThemeSwitcher data-id="element-20" />
    </div>;
}
export function App() {
  return <ThemeProvider data-id="element-21">
      <MagazineContent data-id="element-22" />
    </ThemeProvider>;
}